import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';

// The form keeps a number; grouping is applied only to the displayed price.
@Directive({
   selector: 'input[appPrecioMiles]',
   providers: [
      { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PrecioMilesDirective), multi: true },
      { provide: NG_VALIDATORS, useExisting: forwardRef(() => PrecioMilesDirective), multi: true },
   ],
})
export class PrecioMilesDirective implements ControlValueAccessor, Validator {
   private value: number | null = null;
   private invalid = false;
   private onChange: (value: number | null) => void = () => { };
   private onTouched: () => void = () => { };
   private readonly formatter = new Intl.NumberFormat('es-CL', { maximumFractionDigits: 20 });

   constructor(private element: ElementRef<HTMLInputElement>, private renderer: Renderer2) { }

   writeValue(value: number | string | null): void {
      this.value = value == null || value === '' ? null : Number(value);
      this.invalid = this.value !== null && !Number.isFinite(this.value);
      this.display(this.invalid || this.value === null ? '' : this.formatter.format(this.value));
   }

   registerOnChange(fn: (value: number | null) => void): void { this.onChange = fn; }
   registerOnTouched(fn: () => void): void { this.onTouched = fn; }
   setDisabledState(disabled: boolean): void { this.renderer.setProperty(this.element.nativeElement, 'disabled', disabled); }
   validate(_control: AbstractControl): ValidationErrors | null { return this.invalid ? { precioFormato: true } : null; }

   @HostListener('input', ['$event.target.value'])
   input(text: string): void {
      const raw = text.trim();
      // Accept a Chilean number, including pasted grouping and decimal commas.
      const matches = /^-?(?:(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d*)?|,\d+)$/.test(raw);
      const number = raw ? Number(raw.replace(/\./g, '').replace(',', '.')) : null;
      this.invalid = !!raw && (!matches || !Number.isFinite(number));
      this.value = this.invalid ? null : number;
      this.onChange(this.value);
   }

   @HostListener('focus')
   focus(): void {
      if (!this.invalid) this.display(this.element.nativeElement.value.replace(/\./g, ''));
   }

   @HostListener('blur')
   blur(): void {
      if (!this.invalid) this.display(this.value === null ? '' : this.formatter.format(this.value));
      this.onTouched();
   }

   private display(value: string): void { this.renderer.setProperty(this.element.nativeElement, 'value', value); }
}
